import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    '& > :not(:last-child)': {
      marginRight: '4px'
    },

    '& .more': {
      color: theme.palette.primary.main,
      cursor: 'default'
    }
  },

  task: {
    border: '2px solid',
    borderRadius: '50%',
    boxSizing: 'border-box',
    width: '1.5rem',
    height: '1.5rem',
    padding: '0.1625rem',
    fontSize: theme.size.base
  },

  taskDue: {
    borderColor: theme.palette.indicator.red,
    color: theme.palette.indicator.red
  },

  taskSoon: {
    borderColor: theme.palette.indicator.orange,
    color: theme.palette.indicator.orange
  },

  taskGood: {
    borderColor: theme.palette.indicator.green,
    color: theme.palette.indicator.green
  },

  details: {
    display: 'flex',
    flexDirection: 'column'
  }
}))

export default useStyles
